import { Box, Typography } from '@mui/material';
import React from 'react';
import { useGetDashboardEventsStats } from '../../../services/react-query/dashboard/useGetDashboardEventsStats';
import { Loading } from '../../../uikit';
import { footerContainerStyles, footerCountDivStyles, footerCountProps, footerLabelProps } from '../dashboardStyles';
import { EventFilterParam } from '../../../services/react-query/events';

interface IEventFooterProps {
  filters: EventFilterParam;
}

export function EventFooter({ filters }: IEventFooterProps) {
  const { data, isLoading } = useGetDashboardEventsStats({
    params: { filters },
  });

  if (isLoading || !data) return <Loading />;

  return (
    <Box sx={footerContainerStyles}>
      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{data.events_count}</Typography>
        <Typography {...footerLabelProps}>
          Events
        </Typography>
      </Box>
      <Box sx={footerCountDivStyles}>
        <Typography {...footerCountProps}>{data.employees_count}</Typography>
        <Typography {...footerLabelProps}>
          Employees
        </Typography>
      </Box>
    </Box>
  );
}
